module.exports = __webpack_public_path__ + "static/img/朱总 (2).837c7e71.png";